<template>
  <!-- <div id="refund-exchange">
    <div
      id="refund-exchange-intro"
      class="support-subject-intro support-content"
      v-html="refundExchangeIntro"
    ></div> -->

    <div id="refund-exchange-form-wrapper" class="support-form-wrapper">
      <div class="support-form-title text-center text-uppercase">Thanks for your reflection! Your review help us improving our products and service. </div>
      <!-- <v-form id="refund-exchange-form-input" ref="form" v-model="validForm" lazy-validation>
        <v-row dense>
          <v-col cols="12">
            <div class="support-form-label">Reason For Request</div>
            <v-select
              color="#333333"
              v-model="refundExchangeForm.reason"
              :items="refundExchangeReasons"
              outlined
              :rules="requestReasonRule"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <div class="support-form-label">Amazon Order Id</div>
            <v-text-field
              v-model="refundExchangeForm.amazonOrderId"
              outlined
              autocomplete
              color="#333333"
              class="support-form-field"
              required
              dense
              :rules="amazonOrderIdRule"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="support-form-label">Email Address</div>
            <v-text-field
              v-model="refundExchangeForm.email"
              single-line
              outlined
              autocomplete
              color="#333333"
              class="support-form-field"
              required
              height="45px"
              :rules="emailAddressRule"
            ></v-text-field>
          </v-col>
        </v-row>
        <div id="request-type-selection-wrapper">
          <v-radio-group v-model="refundExchangeForm.requestType" row mandatory dense>
            <v-radio color="#e2211c" label="Exchange"></v-radio>
            <v-radio color="#e2211c" label="Refund"></v-radio>
          </v-radio-group>
        </div>
        <div class="support-form-label">Request Detail</div>
        <v-textarea
          v-model="refundExchangeForm.requestDetail"
          color="#333333"
          outlined
          dense
          required
          :rules="formDetailRule"
        ></v-textarea>
        <div id="refund-exchange-submit-button" class="text-center mt-sm-6">
          <v-btn
            :disabled="!validForm"
            @click="submit"
            color="#e2211c"
            outlined
            full-width
            width="400px"
            height="40px"
            :loading="refundExchangeRequestSending"
          >send request</v-btn>
        </div>
      </v-form> -->
                <div class="box-right-form-mobile grade-mobile" v-if="showBoxGrade">
              <div class="star-mobile">
                  <img @mouseover="mouseOver(1)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(1)"
                       :src="star1" >
                   <img @mouseover="mouseOver(2)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(2)"
                        :src="star2">
                    <img @mouseover="mouseOver(3)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(3)"
                       :src="star3" >
                   <img @mouseover="mouseOver(4)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(4)"
                      :src="star4" >
                    <img @mouseover="mouseOver(5)" 
        	            @mouseleave="mouseLeave"
                      @click="starClick(5)"
                       :src="star5">    
                    </div>


             <div class="box-content-text from gradefrom">
                      <form action="https://api.1byonehealth.com/ap/review" method="post" id="gradefrom">
                        <input type="hidden" id="star-num" name="starnum" v-model="starNum"></input>
                          <div
                            v-for="tag in tags"
                            :key="tag.value"
                          >
                            <span class="tagClass" @click="tagClick(tag.value)">{{ tag.value }}</span>
                          </div>
                          <br>
                          <br>
                        <span>Review*</span>
                        <br>
                        <input id="gradeReview" type="text" name="Review" placeholder="" />
                        <br>
                        <br>
                        <br>
                        <input id="gradeName" type="text" name="Name" placeholder="Name*" />
                        <input id="gradeEmail" type="text" name="email" placeholder="Email*" />
                        <br>
                        <br>
                        <span>To encourage customers to leave a review, we will send some of the lucky customers who leave the review a surprise bonus or cash reward</span>
                        <button type="button" @click="fromSubmit">SUBMIT</button>
                        <div class="after-contact-box" v-if="showAfterBox">
                          <p>How can we help?</p>
                          <p>Call: +1909-391-3888</p>
                          <p>Email: help@1byone.com</p>
                        </div>
                      </form>
                    </div>
               </div>




               
                <div class="box-right-form received" v-if="showReceived">
                  <div>
                    <span>We have received your feedback and will contact</span>
                    <br>
                    <span>you as soon as possible.</span>
                    <br>
                  <a href="/">close</a>
                </div>






             </div> 
                  <!-- 分享 -->
                <div class="share-mobile " v-if="showBoxShare">
                  <h4>You are almost done! </h4>
                  <br>
                  <span>We've got your review. And we will appreciate it if you are willing to share your sincere comments on Amazon. Your reviews create value and make a huge difference for other customers and us!  We'll copy your review to your clipboard, so all you'll need to do is right-click and paste it on Amazon.com's site.</span>
                  <br>
                  <a :href="spUrl" target="_blank">
                    <img border="0" src="../../assets/share.png" width="281" height="61"/>
                  </a>
                </div>

            

    </div>
  </div>
</template>


<script>
import fullStar from "../../assets/fullStar.png";
import hollowStar from "../../assets/hollowStar.png";
import {
  requestReasonRule,
  emailAddressRule,
  amazonOrderIdRule,
  formDetailRule
} from "../../utils/formRulesCheck";

import { requestRefundExchange } from "../../api/dataFactory";
import customerServiceMixins from "../../mixins/customerServiceMixins";

export default {
  mixins: [customerServiceMixins],
  metaInfo: {
    title: "Refund & Exchange | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health gives user free support,30-day money-back guarantee for any reason, and 12-month warranty for quality-related issues."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone health, refund, exchange, replacement, free replacement"
      }
    ]
  },
  data() {
    return {
      spId:"A100",
      tags:null,
      spUrl:"https://www.amazon.com/review/create-review?&asin=B07FXTB52B:5",
      starNum:0,
      showAfterBox:false,
      showReceived:false,
      showBoxGrade:true,
showBoxShare:false,
star1:hollowStar,
    star2:hollowStar,
    star3:hollowStar,
    star4:hollowStar,
    star5:hollowStar,
  tags:null,
      requestReasonRule,
      emailAddressRule,
      amazonOrderIdRule,
      formDetailRule,
      validForm: true,
      refundExchangeIntro:
        "Thank you for visiting our after-sales self-service webpage. Here, we hope to help you resolve whatever problems you are experiencing. Were very sorry for whatever inconvenience your purchase may have caused you. </br>Please kindly be advised that all of our 1byone products come with a hassle-free warranty. You can find your precise warranty period by checking the literature inside the product box or verifying the warranty with our customer service team. If your product does not meet your needs during the warranty period, please contact us via the refund form below and let us know what we can do to help you.</br>Moreover, you can always check the Support section of this website to find product FAQs and Instruction Manuals to help resolve product issues on your own. </br>Thank you in advance for providing all necessary information so our team can quickly assist you.",
      refundExchangeReasons: [
        "Damaged upon arrival",
        "Defective",
        "Sent wrong item",
        "Ordered wrong item",
        "Others"
      ],
    //产品评价标签
  A03tags:[
     {
       value:"Works well",
     },
     {
       value:"Great value and useful",
     },
     {
       value:"Good buy",
     },
     {
       value:"Accurate and consistent",
     },
     {
       value:"Worth the money",
     },
      {
       value:"Great scale",
     }
  ],

    A09tags:[
     {
       value:"Works well",
     },
     {
       value:"Great value and useful",
     },
     {
       value:"Good buy",
     },
     {
       value:"Accurate and consistent",
     },
     {
       value:"Worth the money",
     },
      {
       value:"Great scale",
     }
  ],
      refundExchangeForm: {
        reason: "",
        amazonOrderId: "",
        email: "",
        requestType: "",
        requestDetail: ""
      },
      refundExchangeRequestSending: false
    };
  },


     mounted:function(){
         
          this.spId=sessionStorage.getItem("productID");
     },
  methods: {
    // async submit() {
    //   if (this.$refs.form.validate()) {
    //     this.refundExchangeRequestSending = true;
    //     let result = await requestRefundExchange(
    //       this.buildRefundExchangeRequest()
    //     );
    //     this.refundExchangeRequestSending = false;
    //     if (result) {
    //       this.$emit(
    //         "onCustomerServiceRequestSubmitted",
    //         true,
    //         "Your refund & exchange request is submitted, we will contact you shortly via email"
    //       );
    //     } else {
    //       this.$emit(
    //         "onCustomerServiceRequestFailed",
    //         true,
    //         "There is problem when submitting the request. Please try again later"
    //       );
    //     }
    //   }
    // },
    // buildRefundExchangeRequest() {
    //   let request = new FormData();
    //   request.append("requestReason", this.refundExchangeForm.reason);
    //   request.append("amazonOrderId", this.refundExchangeForm.amazonOrderId);
    //   request.append("email", this.refundExchangeForm.email);
    //   request.append("requestType", this.refundExchangeForm.requestType);
    //   request.append("requestDetail", this.refundExchangeForm.requestDetail);
    //   request.append("recognizedUserEmail", this.recognizedUserEmail);
    //   return request;
    // }

   
  

 // 星级评分的提交
    fromSubmit(){
      var gradeReview = document.getElementById("gradeReview").value;
      var gradeName =document.getElementById("gradeName").value;
      var gradeEmail =document.getElementById("gradeEmail").value;
      var country;
      if(sessionStorage.getItem("asinRegion")=="EU"){
        country =this.radioVal;
      }else{
        country=sessionStorage.getItem("asinRegion");
      }
     
       var istrue = true;
   
      if(this.starNum<=3){
        if(gradeReview==""||gradeReview==null){
                document.getElementById("gradeReview").style.border="1px solid red"
              istrue = false;
              return;
            }else{
              istrue=true;
            } 

        if(gradeName=="" ||gradeName==null){
          document.getElementById("gradeName").style.border="1px solid red"
           istrue = false;
        }else{
           istrue=true;
        }

        if(gradeEmail=="" ||gradeEmail==null){
          document.getElementById("gradeEmail").style.border="1px solid red"
          istrue = false;
        }else{
          istrue=true;
        }

        if(!this.checkEmail(gradeEmail)){
          document.getElementById("gradeEmail").style.border="1px solid red"
          istrue = false;
          }else{
        istrue=true;
       }

      }else{
        istrue=true;
      }

      

      
      
    

        if(istrue){
       this.$axios({
          
              url: defaultAxiosConfig.baseURL+"/ap/comment",
          //     url: "http://localhost:5000/ap/comment",
              method: "post",
              params: {"product_id":this.spId,"score": this.starNum, "review": gradeReview,"name":gradeName,"email":gradeEmail,"country":country}
            }).then(res => {
              console.log(res);
            });
      if(this.starNum>3){
             let text = document.getElementById('gradeReview');
            text.select();
            document.execCommand('Copy');
            this.chooseSP(this.spId);
            this.showfengxiang();
           }else{
            this.showfankuichenggong();
            
           }
      }
        },


  showfengxiang(){
      this.boxclear();
      this.showBox = true; 
      this.showBoxCU=true;
      this.showBoxShare =true;
    },
     showfankuichenggong(){
       this.boxclear();
        this.showBox = true; 
      this.showBoxCU=true;
       this.showReceived=true;

    },
    boxclear(){
      this.twoDiv=false,
      this.showBoxText=false,
      this.showBoxCUright=false,
      this.showBoxAmazon=false,
      this.showBoxForm=false,
      this.showRightForm=false,
      this.showBoxGrade=false,
      this.showBoxShare=false,
      this.showBoxCU=false,
      this.showBox=false,
      this.showboxContact=false,
      this.showloginsuccessful=false,
      this.showReceived=false,
      this.fromcu=false
    },

  mouseOver(num){
          if(num==1){
              this.star1=fullStar;
          }else if(num==2){
              this.star1=fullStar;
              this.star2=fullStar;
          }else if(num==3){
              this.star1=fullStar;
              this.star2=fullStar;
              this.star3=fullStar;
          }
          else if(num==4){
              this.star1=fullStar;
              this.star2=fullStar;
              this.star3=fullStar;
              this.star4=fullStar;
          }else{
              this.star1=fullStar;
              this.star2=fullStar;
              this.star3=fullStar;
              this.star4=fullStar;
              this.star5=fullStar;
          }
            
        },


        mouseLeave() {
         if(this.isClick==false){
              this.star1=hollowStar;
              this.star2=hollowStar;
              this.star3=hollowStar;
              this.star4=hollowStar;
              this.star5=hollowStar;
          }
          else{
             if(this.starNum==1){
              this.star2=hollowStar;
              this.star3=hollowStar;
              this.star4=hollowStar;
              this.star5=hollowStar;
             }else if(this.starNum==2){
              this.star3=hollowStar;
              this.star4=hollowStar;
              this.star5=hollowStar;

             }else if(this.starNum==3){
              this.star4=hollowStar;
              this.star5=hollowStar;
          
             }else if(this.starNum==4){
              this.star5=hollowStar;
             }
          }
        },
      starClick(num){
         this.isClick=true;
         this.starNum=num;
         if(this.starnum!=5){
           this.showAfterBox=true;
         }
         
          if(num==1){
            this.star1=fullStar;
            this.star2=hollowStar;
            this.star3=hollowStar;
            this.star4=hollowStar;
            this.star5=hollowStar;
            
            
          }else if(num==2){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=hollowStar;
            this.star4=hollowStar;
            this.star5=hollowStar;
            
         }else if(num==3){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=fullStar;
            this.star4=hollowStar;
            this.star5=hollowStar;
            
           
         }else if(num==4){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=fullStar;
            this.star4=fullStar;
            this.star5=hollowStar;
             
          }else if(num==5){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=fullStar;
            this.star4=fullStar;
            this.star5=fullStar;
           this.showAfterBox=false;
          }
        },

//  根据spid图片，跟植入asin值
     chooseSP(spId){
       if(spId=="A01"){
         this.spId ="A01";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07FXTB52B:5";
          if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07TLW4FSB:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FXTB52B:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
               }
           }
        }else if(spId=="A02"){
          this.spId ="A02";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07WK1V886:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B081GYJ99R:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07WMTH6MT:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
               }
           }
        }else if(spId=="A03"){
          this.spId ="A03";
        
          this.tags=this.A03tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08D6BJL71:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08D6BJL71:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B089SZG65L:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
               }
           }
        }else if(spId=="A04"){
          this.spId ="A04";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08FQTXDKV:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08FQTXDKV:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08FQTXDKV:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
               }
           }
        }else if(spId=="A05"){
          this.spId ="A05";
         
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }
           }
        }else if(spId=="A06"){
          this.spId ="A06";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B0852DHR53:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07TJS77KR:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFQ7685:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
               }
           }
        }else if(spId=="A07"){
          this.spId ="A07";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XRG2SJR:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XRG2SJR:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07P6BPHRW:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
               }
           }
        }else if(spId=="A08"){
          this.spId ="A08";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XRCHY2J:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XRCHY2J:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07XRHMZPC:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
               }
           }
        }else if(spId=="B01"){
          this.spId ="B01";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08BC1DXHF:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08BC1DXHF:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08BC1DXHF:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
               }
           }
        }else if(spId=="B02"){
          this.spId ="B02";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08BF4RDWP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08BF4RDWP:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08BF4RDWP:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
               }
           }
        }else if(spId=="B03"){
          this.spId ="B03";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B089153D4W:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B089153D4W:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B089153D4W:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
               }
           }
        }else if(spId=="B04"){
          this.spId ="B04";
         
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B089W7H9XK:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B089W7H9XK:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B075DSY8BC:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
               }
           }
        }else if(spId=="B05"){
          this.spId ="B05";
          
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07JG5JDD9:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
           this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07JG5JDD9:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07JG5JDD9:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
               }
           }
        }else if(spId=="D01"){
          this.spId ="D01";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082Y53TCQ:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B082Y53TCQ:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07ZVV561D:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
               }
           }
        }else if(spId=="B06"){
          this.spId ="B06";
          
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XTFW97H:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XTFW97H:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07XTFW97H:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
               }
           }
        }else if(spId=="E01"){
          this.spId ="E01";
          
         if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082V7WB61:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
           this.spUrl="https://www.amazon.ca/review/create-review?&asin=B082V7WB61:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B082V7WB61:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
               }
           }
        }else{
           this.spId ="A05";
          
          if(sessionStorage.getItem("asinRegion")=="US")
               this.spUrl="https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
                if(sessionStorage.getItem("asinRegion")=="CA")
               this.spUrl="https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
               if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }
          }
        }
     },

  }
};
</script>

<style>
/* .star-mobile img{
 margin-left: 5%;
 width: 15%;

} */
.v-label {
  font-size: 14px;
  color: #333333 !important;
}

.v-input--radio-group {
  height: 40px;
}

#request-type-selection-wrapper .v-input__control {
  margin: auto;
}

.tagClass{
  float: left;
  margin-right: 1em;
  background-color: aqua;
  width: 6em;
  height: 1.6em;
  text-align: center;
  border-radius:6px;
  cursor:pointer;
}
.gradefrom{
  margin-left: 5%;
 
}
.gradefrom button{
  margin-left: 2%;
}
.support-form-wrapper{
  margin-bottom: 5em;
}
.grade-moble{
     width: 100%;
}
/* .share-mobile {
     width: 100%;
}

.share-mobile h4{
     margin-left: 20%;
} */

</style>